import { jsx as _jsx } from "react/jsx-runtime";
import { TruncatedHtmlValue } from "../text/TruncatedHtmlValue.js";
import { LabeledValue } from "./LabeledValue.js";
export const LabeledHtmlValue = ({ lines = 3, label, html, showMoreLabel, showLessLabel, notSetLabel, }) => {
    return (_jsx(LabeledValue, { label: label, children: _jsx(TruncatedHtmlValue, { html: html, lines: lines, showMoreLabel: showMoreLabel, showLessLabel: showLessLabel, notSetLabel: notSetLabel }) }));
};
//# sourceMappingURL=LabeledHtmlValue.js.map